import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem4,
    GridItem6sm12xs12,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    Cenarios,
} from './EstudoCompCenarios'

import {
    TaxaCDIAnual,
    RetornoCDI,
    TaxaJurosAnual,
    TipoMomentoTributacaoIR,
    PercIR,
    TempoMinimoEntreAportesResgatesCalculoIRAnos,
    TaxaInflacaoAnual,
    TaxaRetornoAnualReal,
    TaxaJurosAnualFgts,
    TaxaRetornoAnualFgtsReal,
    ExibirEvolucaoAporteMensalInflacao,
    ExibirEvolucaoRetiradaMensalInflacao,
    ExibirEvolucaoRecursosFinanceirosFinalInflacao,
    DiferenciarTaxasAposAposentadoria,
    TaxaCDIAnualAposAposentadoria,
    RetornoCDIAposAposentadoria,
    TaxaJurosAnualAposAposentadoria,
    TaxaInflacaoAnualAposAposentadoria,
    TaxaRetornoAnualRealAposAposentadoria,
    TaxaJurosAnualFgtsAposAposentadoria,
    TaxaRetornoAnualFgtsRealAposAposentadoria,
} from './EstudoCompTaxas'

import {
    processaValoresDefaultIniciaisCenariosTaxas,
} from './EstudoServiceCenariosTaxas'



const EstudoFormCenariosTaxas = ( { values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca } ) => {

    processaValoresDefaultIniciaisCenariosTaxas(values)

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridContainer>
                    <GridItem6sm12xs12>
                        <CardGridEntradaDados>
                            <CardGridDivHeaderEntradaDados>
                                <CardGridDivEntradaDados>
                                    {LABEL.cenarios}
                                </CardGridDivEntradaDados>
                            </CardGridDivHeaderEntradaDados>

                            <CardGridDivBody>
                                <Cenarios
                                    values={values}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                />
                            </CardGridDivBody>
                        </CardGridEntradaDados>
                    </GridItem6sm12xs12>

                    <GridItem6sm12xs12>
                        <CardGridEntradaDados>
                            <CardGridDivHeaderEntradaDados>
                                <CardGridDivEntradaDados>
                                    {LABEL.taxas}
                                </CardGridDivEntradaDados>
                            </CardGridDivHeaderEntradaDados>

                            <CardGridDivBody>
                                <GridContainer>
                                    <GridItem4>
                                        <TaxaCDIAnual
                                            values={values}
                                            handleChange={handleChange}
                                        /> 
                                    </GridItem4>
                                    <GridItem4>
                                        <RetornoCDI
                                            values={values}
                                            handleChange={handleChange}
                                        /> 
                                    </GridItem4>
                                    <GridItem4>
                                        <TaxaJurosAnual
                                            values={values}
                                            handleChange={handleChange}
                                        /> 
                                    </GridItem4>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem4>
                                        <TaxaInflacaoAnual
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem4>
                                    <GridItem4>
                                        <TaxaRetornoAnualReal
                                            values={values}
                                            handleChange={handleChange}
                                            label={LABEL.taxaRetornoAnualReal}
                                        />
                                    </GridItem4>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem4>
                                        <TaxaJurosAnualFgts
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem4>
                                    <GridItem4>
                                        <TaxaRetornoAnualFgtsReal
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem4>
                                </GridContainer>
                               
                                <GridContainer>
                                    <GridItem4>
                                        <TipoMomentoTributacaoIR
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem4>

                                    {(values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRComeCotas ||
                                    values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL ||
                                    values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                    values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                        <GridItem4>
                                            <PercIR
                                                values={values}
                                                handleChange={handleChange}
                                            />
                                        </GridItem4>
                                    )}

                                    {(values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                    values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                        <GridItem4>
                                            <TempoMinimoEntreAportesResgatesCalculoIRAnos
                                                values={values}
                                                handleChange={handleChange}
                                            />
                                        </GridItem4>
                                    )}
                                </GridContainer>

                                {linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                    <>
                                        {!values.diferenciarTaxasAposAposentadoria &&
                                        values.utilizarPercRentabilidadeAnualRecursosFinanceiros && (
                                            <GridContainer>
                                                <GridItem12>
                                                    <CheckboxPadrao
                                                        name="utilizarPercRentabilidadeAnualRecursosFinanceiros"
                                                        label={LABEL.utilizarPercRentabilidadeAnualRecursosFinanceiros}
                                                        checked={values.utilizarPercRentabilidadeAnualRecursosFinanceiros}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem12>
                                            </GridContainer>
                                        )}

                                        <GridContainer>
                                            <GridItem12>
                                                <ExibirEvolucaoAporteMensalInflacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem12>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem12>
                                                <ExibirEvolucaoRetiradaMensalInflacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem12>
                                        </GridContainer>
                                        
                                        <GridContainer>
                                            <GridItem12>
                                                <ExibirEvolucaoRecursosFinanceirosFinalInflacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem12>
                                        </GridContainer>

                                        {!values.utilizarPercRentabilidadeAnualRecursosFinanceiros && (
                                            <GridContainer>
                                                <GridItem12>
                                                    <DiferenciarTaxasAposAposentadoria
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem12>
                                            </GridContainer>
                                        )}

                                        {values.diferenciarTaxasAposAposentadoria && (
                                            <>
                                                <GridContainer>
                                                    <GridItem4>
                                                        <TaxaCDIAnualAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                    <GridItem4>
                                                        <RetornoCDIAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                        /> 
                                                    </GridItem4>
                                                    <GridItem4>
                                                        <TaxaJurosAnualAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                        /> 
                                                    </GridItem4>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem4>
                                                        <TaxaInflacaoAnualAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                    <GridItem4>
                                                        <TaxaRetornoAnualRealAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                            label={LABEL.taxaRetornoAnualReal}
                                                        />
                                                    </GridItem4>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem4>
                                                        <TaxaJurosAnualFgtsAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                    <GridItem4>
                                                        <TaxaRetornoAnualFgtsRealAposAposentadoria
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                </GridContainer>
                                            </>
                                        )}
                                    </>
                                )}
                            </CardGridDivBody>
                        </CardGridEntradaDados>
                    </GridItem6sm12xs12>
                </GridContainer>
            </GridContainer>
        </ValidatorForm>
    )
}

export default EstudoFormCenariosTaxas